import React, { useState, useEffect } from 'react';
import {
  Package,
  Search,
  Filter,
  Eye,
  Edit,
  Trash2,
  CheckCircle,
  AlertTriangle,
  Calendar,
  Truck,
  MapPin,
  X,
  TrendingUp,
  TrendingDown,
  Image as ImageIcon,
  Upload,
  Link as LinkIcon,
  XCircle,
  ZoomIn,
  Download,
  Layers3,
  PackageOpen,
  Plus,
  Check,
  ChevronDown,
  ChevronUp,
  Box,
  Clock
} from 'lucide-react';
import { authFetch } from "../utils/authFetch";

const ProductsList = ({ onDeleteProduct, API_URL: propAPI_URL, onProductsUpdate, token }) => {
  const API_URL = process.env.REACT_APP_API_URL
    || (window.location.hostname === 'localhost'
      ? 'http://localhost:3001/api'
      : 'https://alvarezbohlback-production.up.railway.app/api');

  const [products, setProducts] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [subfamilias, setSubfamilias] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [loading, setLoading] = useState(!!token);

  const [searchTerm, setSearchTerm] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const [filterProveedor, setFilterProveedor] = useState("");
  const [filterFamilia, setFilterFamilia] = useState("");
  const [filterStock, setFilterStock] = useState("");

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [expandedLotes, setExpandedLotes] = useState({});

  const [editFormData, setEditFormData] = useState({
    codigo_barras_mayor: "",
    codigo_barras_intermedia: "",
    codigo_barras_minima: "",
    cod_articulo: "",
    descripcion: "",
    proveedor_id: "",
    unidad_negocio_proveedor: "",
    codigo_articulo_proveedor: "",
    familia_id: "",
    subfamilia_id: "",
    categoria_id: "",
    subcategoria_id: "",
    unidad_mayor: "",
    unidad_display: "",
    cantidad_display_por_unidad_mayor: "",
    unidad_base: "",
    cantidad_unidad_base_por_display: "",
    peso: "",
    volumen: "",
    costo_real: "",
    costo_promedio: "",
    price: "",
    cod_almacen: "",
    imagen_url: "",
    min_stock: ""
  });

  const [imageUploadMode, setImageUploadMode] = useState("file");
  const [imageUrl, setImageUrl] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [imageFile, setImageFile] = useState(null);

  const [hasDisplay, setHasDisplay] = useState(false);
  const [hasUnidadBase, setHasUnidadBase] = useState(false);

  const unidadesMedidaOptions = [
    "Caja", "Tira", "Sachet", "Unidad", "Paquete", "Bulto", "BLS", "DPK", "SCH", "UND", "Display"
  ];

  const almacenesOptions = [
    "01", "02", "ALM-BUENO", "ALM-MAL-ESTADO"
  ];

  useEffect(() => {
    if (token) {
      loadInitialData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const loadInitialData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        loadProducts(),
        loadCategorias(),
        loadProveedores(),
        loadFamilias()
      ]);
      setLoading(false);
    } catch (err) {
      console.error('Error loading data:', err);
      setLoading(false);
    }
  };

  const loadProducts = async () => {
    try {
      const response = await authFetch(`${API_URL}/products`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response) return;
      const result = await response.json();
      if (result.success) setProducts(result.data);
    } catch (err) {
      console.error('Error loading products:', err);
    }
  };

  const loadCategorias = async () => {
    try {
      const response = await authFetch(`${API_URL}/categorias`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response) return;
      const result = await response.json();
      if (result.success) setCategorias(result.data);
    } catch (err) {
      console.error('Error loading categorias:', err);
    }
  };

  const loadProveedores = async () => {
    try {
      const response = await authFetch(`${API_URL}/proveedores`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response) return;
      const result = await response.json();
      if (result.success) setProveedores(result.data);
    } catch (err) {
      console.error('Error loading proveedores:', err);
    }
  };

  const loadFamilias = async () => {
    try {
      const response = await authFetch(`${API_URL}/familias`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response) return;
      const result = await response.json();
      if (result.success) setFamilias(result.data);
    } catch (err) {
      console.error('Error loading familias:', err);
    }
  };

  const loadSubfamilias = async (familiaId) => {
    try {
      const response = await authFetch(`${API_URL}/subfamilias/familia/${familiaId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response) return;
      const result = await response.json();
      if (result.success) setSubfamilias(result.data);
    } catch (err) {
      console.error('Error loading subfamilias:', err);
    }
  };

  const loadSubcategorias = async (categoriaId) => {
    try {
      const response = await authFetch(`${API_URL}/subcategorias/categoria/${categoriaId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response) return;
      const result = await response.json();
      if (result.success) setSubcategorias(result.data);
    } catch (err) {
      console.error('Error loading subcategorias:', err);
    }
  };

  useEffect(() => {
    if (editFormData.familia_id) {
      loadSubfamilias(editFormData.familia_id);
    } else {
      setSubfamilias([]);
      setEditFormData(prev => ({ ...prev, subfamilia_id: "" }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editFormData.familia_id]);

  useEffect(() => {
    if (editFormData.categoria_id) {
      loadSubcategorias(editFormData.categoria_id);
    } else {
      setSubcategorias([]);
      setEditFormData(prev => ({ ...prev, subcategoria_id: "" }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editFormData.categoria_id]);

  const getTotalStock = (product) => {
    if (!product.stock_lotes?.lotes) return 0;
    let total = 0;
    for (const lote of product.stock_lotes.lotes) {
      if (lote.ubicaciones && Array.isArray(lote.ubicaciones)) {
        for (const ubicacion of lote.ubicaciones) {
          total += ubicacion.stock_unidades || 0;
        }
      }
    }
    return total;
  };

  const getTotalCajas = (product) => {
    if (!product.stock_lotes?.lotes) return 0;
    return product.stock_lotes.lotes.reduce((sum, lote) => sum + (lote.cajas_fisicas || 0), 0);
  };

  const getProximoVencimiento = (product) => {
    if (!product.stock_lotes?.lotes || product.stock_lotes.lotes.length === 0) return null;
    const lotesOrdenados = [...product.stock_lotes.lotes].sort(
      (a, b) => new Date(a.fecha_vencimiento) - new Date(b.fecha_vencimiento)
    );
    return lotesOrdenados[0];
  };

  const getDiasHastaVencimiento = (fecha) => {
    if (!fecha) return null;
    const hoy = new Date();
    const vencimiento = new Date(fecha);
    return Math.ceil((vencimiento - hoy) / (1000 * 60 * 60 * 24));
  };

  const getVencimientoColor = (dias) => {
    if (dias === null) return 'neutral';
    if (dias < 0) return 'expired';
    if (dias <= 30) return 'critical';
    if (dias <= 90) return 'warning';
    return 'good';
  };

  const getUbicacionesResumen = (product) => {
    if (!product.stock_lotes?.lotes) return 'Sin ubicación';
    const ubicaciones = [];
    for (const lote of product.stock_lotes.lotes) {
      if (lote.ubicaciones && Array.isArray(lote.ubicaciones)) {
        for (const ubicacion of lote.ubicaciones) {
          if (ubicacion.codigo_ubicacion && !ubicaciones.includes(ubicacion.codigo_ubicacion)) {
            ubicaciones.push(ubicacion.codigo_ubicacion);
          }
        }
      }
    }
    if (ubicaciones.length === 0) return 'Sin ubicación';
    if (ubicaciones.length === 1) return ubicaciones[0];
    return `${ubicaciones[0]} +${ubicaciones.length - 1}`;
  };

  const handleView = (product) => {
    setSelectedProduct(product);
    setShowDetailModal(true);
    setExpandedLotes({});
  };

  const toggleLoteExpansion = (loteId) => {
    setExpandedLotes(prev => ({ ...prev, [loteId]: !prev[loteId] }));
  };

  const handleEdit = (product) => {
    setEditingProduct(product);
    setHasDisplay(!!product.unidad_display);
    setHasUnidadBase(!!product.unidad_base);
    setEditFormData({
      codigo_barras_mayor: product.codigo_barras_mayor || "",
      codigo_barras_intermedia: product.codigo_barras_intermedia || "",
      codigo_barras_minima: product.codigo_barras_minima || "",
      cod_articulo: product.cod_articulo || "",
      descripcion: product.descripcion || "",
      proveedor_id: product.proveedor_id || "",
      unidad_negocio_proveedor: product.unidad_negocio_proveedor || "",
      codigo_articulo_proveedor: product.codigo_articulo_proveedor || "",
      familia_id: product.familia_id || "",
      subfamilia_id: product.subfamilia_id || "",
      categoria_id: product.categoria_id || "",
      subcategoria_id: product.subcategoria_id || "",
      unidad_mayor: product.unidad_mayor || "",
      unidad_display: product.unidad_display || "",
      cantidad_display_por_unidad_mayor: product.cantidad_display_por_unidad_mayor || "",
      unidad_base: product.unidad_base || "",
      cantidad_unidad_base_por_display: product.cantidad_unidad_base_por_display || "",
      peso: product.peso || "",
      volumen: product.volumen || "",
      costo_real: product.costo_real || "",
      costo_promedio: product.costo_promedio || "",
      price: product.price || "",
      cod_almacen: product.cod_almacen || "",
      imagen_url: product.imagen_url || "",
      min_stock: product.min_stock || ""
    });
    if (product.imagen_url) setImagePreview(product.imagen_url);
    if (product.familia_id) loadSubfamilias(product.familia_id);
    if (product.categoria_id) loadSubcategorias(product.categoria_id);
    setShowEditModal(true);
  };

  const handleUpdate = async () => {
    if (!editingProduct) return;
    try {
      const updateData = {
        codigo_barras_mayor: editFormData.codigo_barras_mayor || null,
        codigo_barras_intermedia: editFormData.codigo_barras_intermedia || null,
        codigo_barras_minima: editFormData.codigo_barras_minima,
        cod_articulo: editFormData.cod_articulo || null,
        descripcion: editFormData.descripcion || null,
        proveedor_id: parseInt(editFormData.proveedor_id) || null,
        unidad_negocio_proveedor: editFormData.unidad_negocio_proveedor || null,
        codigo_articulo_proveedor: editFormData.codigo_articulo_proveedor || null,
        familia_id: parseInt(editFormData.familia_id) || null,
        subfamilia_id: parseInt(editFormData.subfamilia_id) || null,
        categoria_id: parseInt(editFormData.categoria_id) || null,
        subcategoria_id: parseInt(editFormData.subcategoria_id) || null,
        unidad_mayor: editFormData.unidad_mayor,
        unidad_display: hasDisplay ? editFormData.unidad_display : null,
        cantidad_display_por_unidad_mayor: hasDisplay ? parseInt(editFormData.cantidad_display_por_unidad_mayor) : null,
        unidad_base: hasUnidadBase ? editFormData.unidad_base : null,
        cantidad_unidad_base_por_display: hasUnidadBase ? parseInt(editFormData.cantidad_unidad_base_por_display) : null,
        peso: parseFloat(editFormData.peso) || null,
        volumen: parseFloat(editFormData.volumen) || null,
        costo_real: parseFloat(editFormData.costo_real) || null,
        costo_promedio: parseFloat(editFormData.costo_promedio) || null,
        price: parseFloat(editFormData.price) || null,
        cod_almacen: editFormData.cod_almacen || null,
        imagen_url: editFormData.imagen_url || null,
        min_stock: parseInt(editFormData.min_stock) || 0
      };

      const response = await authFetch(`${API_URL}/products/${editingProduct.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(updateData)
      });
      if (!response) return;

      const result = await response.json();
      if (result.success) {
        alert('✅ Producto actualizado correctamente');
        await loadProducts();
        handleCloseEditModal();
      } else {
        alert('❌ Error: ' + result.error);
      }
    } catch (err) {
      console.error('Error updating product:', err);
      alert('❌ Error al actualizar producto');
    }
  };

  const handleDelete = async (productId) => {
    const product = products.find(p => p.id === productId);
    if (!window.confirm(
      `¿Está seguro de eliminar el producto "${product.descripcion || product.codigo_barras_minima}"?\n\n` +
      `Esta acción eliminará:\n` +
      `• El producto\n` +
      `• Todos sus lotes (${product.stock_lotes?.lotes?.length || 0})\n` +
      `• Todas sus ubicaciones\n` +
      `• Stock total: ${getTotalStock(product) || 0} unidades\n\n` +
      `Esta acción NO se puede deshacer.`
    )) return;

    try {
      const response = await authFetch(`${API_URL}/products/${productId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response) return;
      const result = await response.json();
      if (result.success) {
        alert('✅ Producto eliminado correctamente');
        if (onProductsUpdate && typeof onProductsUpdate === 'function') {
          await onProductsUpdate();
        } else {
          await loadProducts();
        }
      } else {
        alert('❌ Error: ' + result.error);
      }
    } catch (err) {
      console.error('Error deleting product:', err);
      alert('❌ Error al eliminar producto');
    }
  };

  const handleProductImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) { alert('La imagen no puede superar los 5MB'); return; }
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      if (!allowedTypes.includes(file.type)) { alert('Solo se permiten imágenes: JPEG, PNG, GIF, WEBP'); return; }
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleUploadImageFromFile = async () => {
    if (!imageFile) { alert('Por favor seleccione una imagen'); return; }
    if (!editFormData.codigo_barras_minima) { alert('Por favor ingrese el código de barras mínima primero'); return; }
    setUploadingImage(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('file', imageFile);
      formDataToSend.append('barcode', editFormData.codigo_barras_minima);
      const response = await authFetch(`${API_URL}/products/upload-image`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formDataToSend
      });
      if (!response) return;
      const result = await response.json();
      if (result.success) {
        setEditFormData(prev => ({ ...prev, imagen_url: result.data.imagen_url }));
        alert('✅ Imagen subida correctamente');
      } else {
        alert('❌ Error: ' + result.error);
      }
    } catch (err) {
      console.error('Error uploading image:', err);
      alert('❌ Error al subir la imagen');
    } finally {
      setUploadingImage(false);
    }
  };

  const handleUploadImageFromUrl = async () => {
    if (!imageUrl.trim()) { alert('Por favor ingrese una URL'); return; }
    if (!editFormData.codigo_barras_minima) { alert('Por favor ingrese el código de barras mínima primero'); return; }
    try { new URL(imageUrl); } catch { alert('URL inválida'); return; }
    setUploadingImage(true);
    try {
      const response = await authFetch(`${API_URL}/products/image-from-url`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ image_url: imageUrl, barcode: editFormData.codigo_barras_minima, use_direct_url: false })
      });
      if (!response) return;
      const result = await response.json();
      if (result.success) {
        setEditFormData(prev => ({ ...prev, imagen_url: result.data.imagen_url }));
        setImagePreview(result.data.imagen_url);
        alert('✅ Imagen cargada correctamente');
      } else {
        alert('❌ Error: ' + result.error);
      }
    } catch (err) {
      console.error('Error loading image from URL:', err);
      alert('❌ Error al cargar la imagen');
    } finally {
      setUploadingImage(false);
    }
  };

  const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview(null);
    setImageUrl("");
    setEditFormData(prev => ({ ...prev, imagen_url: "" }));
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditingProduct(null);
    setImageFile(null);
    setImagePreview(null);
    setImageUrl("");
    setImageUploadMode("file");
    setHasDisplay(false);
    setHasUnidadBase(false);
  };

  const toggleDisplayLevel = () => {
    setHasDisplay(!hasDisplay);
    if (!hasDisplay) {
      setEditFormData(prev => ({ ...prev, unidad_display: "", cantidad_display_por_unidad_mayor: "" }));
    }
  };

  const toggleUnidadBaseLevel = () => {
    setHasUnidadBase(!hasUnidadBase);
    if (!hasUnidadBase) {
      setEditFormData(prev => ({ ...prev, unidad_base: "", cantidad_unidad_base_por_display: "" }));
    }
  };

  const handleImageClick = (imageUrl, productDescription) => {
    setSelectedImage({ url: imageUrl, description: productDescription });
    setShowImageModal(true);
  };

  const handleDownloadImage = () => {
    if (!selectedImage?.url) return;
    const link = document.createElement('a');
    link.href = selectedImage.url;
    link.download = `producto-${Date.now()}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const filteredProducts = products.filter((product) => {
    const totalStock = getTotalStock(product);
    const minStock = product.min_stock || 0;
    const matchesSearch =
      (product.codigo_barras_minima || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (product.codigo_barras_mayor || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (product.codigo_barras_intermedia || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (product.descripcion || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (product.proveedores?.nombre || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (product.familias?.nombre || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (product.categorias?.nombre || "").toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = !filterCategory || product.categoria_id === filterCategory;
    const matchesProveedor = !filterProveedor || product.proveedor_id === filterProveedor;
    const matchesFamilia = !filterFamilia || product.familia_id === filterFamilia;
    let matchesStock = true;
    if (filterStock === "low") matchesStock = totalStock <= minStock && totalStock > 0;
    else if (filterStock === "out") matchesStock = totalStock === 0;
    return matchesSearch && matchesCategory && matchesProveedor && matchesFamilia && matchesStock;
  });

  const getCategoryColor = (category) => {
    const colors = {
      "Electrónicos": "#3B82F6", "Alimentarios": "#60A5FA", "Textiles": "#93C5FD",
      "Químicos": "#1E40AF", "Farmacéuticos": "#2563EB", "Alimentos y Bebidas": "#10B981",
      "Alimentos": "#F59E0B", "Snacks": "#8B5CF6", "Mascotas": "#EC4899", "Lácteos": "#06B6D4"
    };
    return colors[category] || "#3B82F6";
  };

  if (loading) {
    return (
      <div className="products-list">
        <div className="loading-container">
          <div className="loader-ring"></div>
          <p>Cargando productos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="products-list">
      {/* ── Filtros y búsqueda ── */}
      <div className="products-header">
        <div className="search-filters">
          <div className="search-wrapper">
            <Search className="search-icon" />
            <input
              type="text"
              placeholder="Buscar productos..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="filter-wrapper">
            <Filter className="filter-icon" />
            <select className="filter-select" value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)}>
              <option value="">Todas las categorías</option>
              {categorias.map((cat) => <option key={cat.id} value={cat.id}>{cat.nombre}</option>)}
            </select>
          </div>
          <div className="filter-wrapper">
            <Filter className="filter-icon" />
            <select className="filter-select" value={filterProveedor} onChange={(e) => setFilterProveedor(e.target.value)}>
              <option value="">Todos los proveedores</option>
              {proveedores.map((prov) => <option key={prov.id} value={prov.id}>{prov.nombre}</option>)}
            </select>
          </div>
          <div className="filter-wrapper">
            <Filter className="filter-icon" />
            <select className="filter-select" value={filterFamilia} onChange={(e) => setFilterFamilia(e.target.value)}>
              <option value="">Todas las familias</option>
              {familias.map((fam) => <option key={fam.id} value={fam.id}>{fam.nombre}</option>)}
            </select>
          </div>
          <div className="filter-wrapper">
            <Filter className="filter-icon" />
            <select className="filter-select" value={filterStock} onChange={(e) => setFilterStock(e.target.value)}>
              <option value="">Todos los stocks</option>
              <option value="low">Stock Bajo</option>
              <option value="out">Sin Stock</option>
            </select>
          </div>
        </div>
      </div>

      {/* ── Tabla de productos ── */}
      <div className="products-table-container glass-panel">
        <div className="table-header">
          <div className="table-title">
            <Package className="table-title-icon" />
            <h3>Productos Registrados</h3>
            <span className="product-count">{filteredProducts.length} productos</span>
          </div>
        </div>

        <div className="table-wrapper">
          <table className="products-table">
            {/* colgroup define anchos fijos para evitar scroll horizontal */}
            <colgroup>
              <col style={{ width: '62px' }} />   {/* imagen */}
              <col style={{ width: '130px' }} />  {/* código */}
              <col style={{ width: '18%' }} />    {/* descripción */}
              <col style={{ width: '10%' }} />    {/* proveedor */}
              <col style={{ width: '80px' }} />   {/* lotes */}
              <col style={{ width: '130px' }} />  {/* vencimiento */}
              <col style={{ width: '9%' }} />     {/* familia */}
              <col style={{ width: '9%' }} />     {/* categoría */}
              <col style={{ width: '110px' }} />  {/* stock */}
              <col style={{ width: '100px' }} />  {/* ubicaciones */}
              <col style={{ width: '95px' }} />   {/* fecha entrada */}
              <col style={{ width: '90px' }} />   {/* estado */}
              <col style={{ width: '108px' }} />  {/* acciones */}
            </colgroup>
            <thead>
              <tr className="table-head-row">
                <th className="th-image">Imagen</th>
                <th className="th-product">Código</th>
                <th className="th-description">Descripción</th>
                <th className="th-supplier">Proveedor</th>
                <th className="th-lotes">Lotes</th>
                <th className="th-expiry">Próx. Vencimiento</th>
                <th className="th-family">Familia</th>
                <th className="th-category">Categoría</th>
                <th className="th-stock">Stock Total</th>
                <th className="th-location">Ubicaciones</th>
                <th className="th-date">F. Entrada</th>
                <th className="th-status">Estado</th>
                <th className="th-actions">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.length === 0 ? (
                <tr>
                  <td colSpan="13" className="no-data">
                    <Package size={48} />
                    <p>No se encontraron productos</p>
                  </td>
                </tr>
              ) : (
                filteredProducts.map((product, index) => {
                  const totalStock = getTotalStock(product);
                  // eslint-disable-next-line no-unused-vars
                  const totalCajas = getTotalCajas(product);
                  const proximoLote = getProximoVencimiento(product);
                  const diasVencimiento = proximoLote ? getDiasHastaVencimiento(proximoLote.fecha_vencimiento) : null;
                  const vencimientoColor = getVencimientoColor(diasVencimiento);
                  const numLotes = product.stock_lotes?.lotes?.length || 0;
                  const minStock = product.min_stock || 0;

                  return (
                    <tr key={product.id} className="product-row" style={{ animationDelay: `${index * 0.05}s` }}>
                      {/* Imagen */}
                      <td className="td-image">
                        {product.imagen_url ? (
                          <div
                            className="product-thumbnail-container"
                            onClick={() => handleImageClick(product.imagen_url, product.descripcion || product.codigo_barras_minima)}
                          >
                            <img src={product.imagen_url} alt={product.descripcion} className="product-thumbnail" />
                            <div className="thumbnail-overlay"><ZoomIn size={20} /></div>
                          </div>
                        ) : (
                          <div className="no-image-placeholder"><Package size={20} /></div>
                        )}
                      </td>

                      {/* Código Artículo */}
                      <td className="td-product">
                        <div className="product-code">
                          <span className="cell-truncate" style={{ fontWeight: 600 }}>{product.cod_articulo || 'N/A'}</span>
                        </div>
                      </td>

                      {/* Descripción */}
                      <td className="td-description">
                        <span className="cell-truncate" title={product.descripcion || 'N/A'}>
                          {product.descripcion || 'N/A'}
                        </span>
                      </td>

                      {/* Proveedor */}
                      <td className="td-supplier">
                        <div className="supplier-info">
                          <Truck size={13} className="cell-icon" />
                          <span className="cell-truncate" title={product.proveedores?.nombre || 'N/A'}>
                            {product.proveedores?.nombre || 'N/A'}
                          </span>
                        </div>
                      </td>

                      {/* Lotes */}
                      <td className="td-lotes">
                        <div className="lotes-badge">
                          <Box size={13} />
                          <span>{numLotes}</span>
                        </div>
                      </td>

                      {/* Próximo vencimiento */}
                      <td className="td-expiry">
                        {proximoLote ? (
                          <div className={`expiry-indicator ${vencimientoColor}`}>
                            <Clock size={13} />
                            <div className="expiry-content">
                              <span className="expiry-date">
                                {new Date(proximoLote.fecha_vencimiento).toLocaleDateString('es-ES')}
                              </span>
                              <span className="expiry-days">
                                {diasVencimiento !== null && (
                                  diasVencimiento < 0
                                    ? `Vencido ${Math.abs(diasVencimiento)}d`
                                    : `${diasVencimiento} días`
                                )}
                              </span>
                            </div>
                          </div>
                        ) : (
                          <span className="text-muted">N/A</span>
                        )}
                      </td>

                      {/* Familia */}
                      <td className="td-family">
                        <span className="family-tag cell-truncate" title={product.familias?.nombre || 'N/A'}>
                          {product.familias?.nombre || 'N/A'}
                        </span>
                      </td>

                      {/* Categoría */}
                      <td className="td-category">
                        <span
                          className="category-badge cell-truncate"
                          title={product.categorias?.nombre || 'N/A'}
                          style={{
                            background: `${getCategoryColor(product.categorias?.nombre)}20`,
                            color: getCategoryColor(product.categorias?.nombre),
                            borderColor: `${getCategoryColor(product.categorias?.nombre)}40`,
                          }}
                        >
                          {product.categorias?.nombre || 'N/A'}
                        </span>
                      </td>

                      {/* Stock */}
                      <td className="td-stock">
                        <div className={`stock-indicator ${totalStock === 0 ? 'out' : totalStock <= minStock ? 'low' : 'good'}`}>
                          {totalStock === 0 ? <TrendingDown size={13} /> : totalStock <= minStock ? <AlertTriangle size={13} /> : <TrendingUp size={13} />}
                          <span>{totalStock} {product.unidad_base || 'uds'}</span>
                        </div>
                      </td>

                      {/* Ubicaciones */}
                      <td className="td-location">
                        <div className="location-cell">
                          <MapPin size={13} className="cell-icon" />
                          <span className="cell-truncate" title={getUbicacionesResumen(product)}>
                            {getUbicacionesResumen(product)}
                          </span>
                        </div>
                      </td>

                      {/* Fecha entrada */}
                      <td className="td-date">
                        <div className="date-info">
                          <Calendar size={13} className="cell-icon" />
                          <span>
                            {product.created_at
                              ? new Date(product.created_at).toLocaleDateString('es-ES', { year: '2-digit', month: '2-digit', day: '2-digit' })
                              : 'N/A'}
                          </span>
                        </div>
                      </td>

                      {/* Estado */}
                      <td className="td-status">
                        <span className={`status-badge ${product.scan_result || 'good'}`}>
                          {product.scan_result === "good" ? (
                            <><CheckCircle size={13} /><span>Óptimo</span></>
                          ) : (
                            <><AlertTriangle size={13} /><span>Defecto</span></>
                          )}
                        </span>
                      </td>

                      {/* Acciones */}
                      <td className="td-actions">
                        <div className="action-buttons">
                          <button className="action-btn view-btn" onClick={() => handleView(product)} title="Ver detalles">
                            <Eye size={14} />
                          </button>
                          <button className="action-btn edit-btn" onClick={() => handleEdit(product)} title="Editar">
                            <Edit size={14} />
                          </button>
                          <button className="action-btn delete-btn" onClick={() => handleDelete(product.id)} title="Eliminar">
                            <Trash2 size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── Modal imagen ampliada ── */}
      {showImageModal && selectedImage && (
        <div className="modal-overlay" onClick={() => setShowImageModal(false)}>
          <div className="modal-content-image" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{selectedImage.description || 'Imagen del Producto'}</h3>
              <div className="image-modal-actions">
                <button className="image-modal-btn download-btn" onClick={handleDownloadImage} title="Descargar imagen">
                  <Download size={18} />
                </button>
                <button className="image-modal-btn close-btn" onClick={() => setShowImageModal(false)} title="Cerrar">
                  <X size={20} />
                </button>
              </div>
            </div>
            <div className="modal-body-image">
              <img src={selectedImage.url} alt={selectedImage.description || 'Producto'} className="modal-image-large" />
            </div>
          </div>
        </div>
      )}

      {/* ── Modal detalles ── */}
      {showDetailModal && selectedProduct && (
        <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
          <div className="modal-content-detail" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Detalles del Producto</h3>
              <button className="modal-close" onClick={() => setShowDetailModal(false)}><X size={20} /></button>
            </div>
            <div className="modal-body-detail">
              {selectedProduct.imagen_url && (
                <div className="product-image-display-modal">
                  <img src={selectedProduct.imagen_url} alt={selectedProduct.descripcion} />
                </div>
              )}
              <div className="detail-grid">
                <div className="detail-section">
                  <h4>Información Básica</h4>
                  {selectedProduct.codigo_barras_mayor && <div className="detail-item"><label>BC Mayor:</label><span>{selectedProduct.codigo_barras_mayor}</span></div>}
                  {selectedProduct.codigo_barras_intermedia && <div className="detail-item"><label>BC Intermedia:</label><span>{selectedProduct.codigo_barras_intermedia}</span></div>}
                  <div className="detail-item"><label>BC Mínima:</label><span>{selectedProduct.codigo_barras_minima || 'N/A'}</span></div>
                  <div className="detail-item"><label>Código Artículo:</label><span>{selectedProduct.cod_articulo || 'N/A'}</span></div>
                  <div className="detail-item"><label>Descripción:</label><span>{selectedProduct.descripcion || 'N/A'}</span></div>
                </div>
                <div className="detail-section">
                  <h4>Proveedor</h4>
                  <div className="detail-item"><label>Nombre:</label><span>{selectedProduct.proveedores?.nombre || 'N/A'}</span></div>
                  <div className="detail-item"><label>Teléfono:</label><span>{selectedProduct.proveedores?.telefono || 'N/A'}</span></div>
                  <div className="detail-item"><label>Email:</label><span>{selectedProduct.proveedores?.email || 'N/A'}</span></div>
                  <div className="detail-item"><label>Unidad de Negocio:</label><span>{selectedProduct.unidad_negocio_proveedor || 'N/A'}</span></div>
                  <div className="detail-item"><label>Código Artículo Prov:</label><span>{selectedProduct.codigo_articulo_proveedor || 'N/A'}</span></div>
                </div>
                <div className="detail-section">
                  <h4>Clasificación</h4>
                  <div className="detail-item"><label>Familia:</label><span>{selectedProduct.familias?.nombre || 'N/A'}</span></div>
                  <div className="detail-item"><label>SubFamilia:</label><span>{selectedProduct.subfamilias?.nombre || 'N/A'}</span></div>
                  <div className="detail-item"><label>Categoría:</label><span>{selectedProduct.categorias?.nombre || 'N/A'}</span></div>
                  <div className="detail-item"><label>SubCategoría:</label><span>{selectedProduct.subcategorias?.nombre || 'N/A'}</span></div>
                </div>
                <div className="detail-section">
                  <h4>Unidades de Medida</h4>
                  <div className="detail-item"><label>Unidad Mayor:</label><span>{selectedProduct.unidad_mayor || 'N/A'}</span></div>
                  {selectedProduct.unidad_display && (
                    <>
                      <div className="detail-item"><label>Unidad Display:</label><span>{selectedProduct.unidad_display}</span></div>
                      <div className="detail-item"><label>Display por U. Mayor:</label><span>{selectedProduct.cantidad_display_por_unidad_mayor}</span></div>
                    </>
                  )}
                  {selectedProduct.unidad_base && (
                    <>
                      <div className="detail-item"><label>Unidad Base:</label><span>{selectedProduct.unidad_base}</span></div>
                      <div className="detail-item"><label>Unidades por Display:</label><span>{selectedProduct.cantidad_unidad_base_por_display}</span></div>
                    </>
                  )}
                </div>
                <div className="detail-section">
                  <h4>Resumen de Stock</h4>
                  <div className="detail-item"><label>Stock Total:</label><span className="stock-value good">{getTotalStock(selectedProduct)} {selectedProduct.unidad_base || 'unidades'}</span></div>
                  <div className="detail-item"><label>Total Cajas:</label><span>{getTotalCajas(selectedProduct)} {selectedProduct.unidad_mayor || 'cajas'}</span></div>
                  <div className="detail-item"><label>Número de Lotes:</label><span>{selectedProduct.stock_lotes?.lotes?.length || 0}</span></div>
                  <div className="detail-item"><label>Stock Mínimo:</label><span>{selectedProduct.min_stock || 0}</span></div>
                </div>
                <div className="detail-section">
                  <h4>Costos</h4>
                  <div className="detail-item"><label>Costo Real:</label><span>{selectedProduct.costo_real ? `S/ ${selectedProduct.costo_real.toFixed(2)}` : 'N/A'}</span></div>
                  <div className="detail-item"><label>Costo Promedio:</label><span>{selectedProduct.costo_promedio ? `S/ ${selectedProduct.costo_promedio.toFixed(2)}` : 'N/A'}</span></div>
                  <div className="detail-item"><label>Precio de Venta:</label><span>{selectedProduct.price ? `S/ ${selectedProduct.price.toFixed(2)}` : 'N/A'}</span></div>
                </div>
                <div className="detail-section">
                  <h4>Medidas y Almacén</h4>
                  <div className="detail-item"><label>Peso:</label><span>{selectedProduct.peso ? `${selectedProduct.peso} kg` : 'N/A'}</span></div>
                  <div className="detail-item"><label>Volumen:</label><span>{selectedProduct.volumen ? `${selectedProduct.volumen} cm³` : 'N/A'}</span></div>
                  <div className="detail-item"><label>Código de Almacén:</label><span>{selectedProduct.cod_almacen || 'N/A'}</span></div>
                </div>
                <div className="detail-section">
                  <h4>Control de Calidad</h4>
                  <div className="detail-item">
                    <label>Estado del Escaneo:</label>
                    <span className={`status-badge ${selectedProduct.scan_result || 'good'}`}>
                      {selectedProduct.scan_result === 'good' ? 'Óptimo' : 'Defectuoso'}
                    </span>
                  </div>
                  <div className="detail-item"><label>Confianza:</label><span>{selectedProduct.confidence || 0}%</span></div>
                  {selectedProduct.issues && selectedProduct.issues.length > 0 && (
                    <div className="detail-item full-width">
                      <label>Problemas Detectados:</label>
                      <ul className="issues-list">
                        {selectedProduct.issues.map((issue, idx) => <li key={idx}>{issue}</li>)}
                      </ul>
                    </div>
                  )}
                </div>
              </div>

              {selectedProduct.stock_lotes?.lotes && selectedProduct.stock_lotes.lotes.length > 0 && (
                <div className="lotes-section">
                  <h4 className="lotes-title">
                    <Box size={18} />
                    <span>Lotes del Producto ({selectedProduct.stock_lotes.lotes.length})</span>
                  </h4>
                  <div className="lotes-list">
                    {selectedProduct.stock_lotes.lotes.map((lote, index) => {
                      const diasVenc = getDiasHastaVencimiento(lote.fecha_vencimiento);
                      const vColor = getVencimientoColor(diasVenc);
                      const isExpanded = expandedLotes[lote.id];
                      let stockLote = 0;
                      if (lote.ubicaciones && Array.isArray(lote.ubicaciones)) {
                        for (const ub of lote.ubicaciones) stockLote += ub.stock_unidades || 0;
                      }
                      return (
                        <div key={lote.id} className="lote-card">
                          <div className="lote-header" onClick={() => toggleLoteExpansion(lote.id)}>
                            <div className="lote-header-left">
                              <span className="lote-number">Lote #{index + 1}</span>
                              <span className="lote-code">{lote.lote}</span>
                              <span className={`lote-expiry-badge ${vColor}`}>
                                <Clock size={12} />
                                {diasVenc !== null && (diasVenc < 0 ? `Vencido` : `${diasVenc} días`)}
                              </span>
                            </div>
                            <div className="lote-header-right">
                              <span className="lote-stock">{stockLote} {selectedProduct.unidad_base || 'uds'}</span>
                              <span className="lote-cajas">{lote.cajas_fisicas} {selectedProduct.unidad_mayor || 'cajas'}</span>
                              {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                            </div>
                          </div>
                          {isExpanded && (
                            <div className="lote-body">
                              <div className="lote-info-grid">
                                <div className="lote-info-item">
                                  <label>Fecha de Compra:</label>
                                  <span>{new Date(lote.fecha_compra).toLocaleDateString('es-ES')}</span>
                                </div>
                                <div className="lote-info-item">
                                  <label>Fecha de Vencimiento:</label>
                                  <span className={`expiry-text ${vColor}`}>{new Date(lote.fecha_vencimiento).toLocaleDateString('es-ES')}</span>
                                </div>
                              </div>
                              {lote.ubicaciones && Array.isArray(lote.ubicaciones) && lote.ubicaciones.length > 0 && (
                                <div className="lote-ubicaciones-section">
                                  <h5>Ubicaciones del Lote</h5>
                                  {lote.ubicaciones.map((ubicacion, ubIndex) => (
                                    <div key={ubIndex} className="ubicacion-item">
                                      <div className="ubicacion-badge">
                                        <MapPin size={16} />
                                        <span className="ubicacion-code">{ubicacion.codigo_ubicacion}</span>
                                      </div>
                                      <div className="lote-stock-section">
                                        <h5>Cantidad en esta ubicación</h5>
                                        <div className="lote-stock-grid">
                                          <div className="lote-stock-item nivel-mayor">
                                            <div className="stock-level-icon"><Package size={16} /></div>
                                            <div className="stock-level-info">
                                              <span className="stock-level-label">{lote.unidad_max}</span>
                                              <span className="stock-level-value">{ubicacion.cantidad_max}</span>
                                            </div>
                                          </div>
                                          {lote.unidad_med && (
                                            <div className="lote-stock-item nivel-display">
                                              <div className="stock-level-icon"><Layers3 size={16} /></div>
                                              <div className="stock-level-info">
                                                <span className="stock-level-label">{lote.unidad_med}</span>
                                                <span className="stock-level-value">{ubicacion.cantidad_med}</span>
                                              </div>
                                            </div>
                                          )}
                                          {lote.unidad_peq && (
                                            <div className="lote-stock-item nivel-base">
                                              <div className="stock-level-icon"><PackageOpen size={16} /></div>
                                              <div className="stock-level-info">
                                                <span className="stock-level-label">{lote.unidad_peq}</span>
                                                <span className="stock-level-value">{ubicacion.cantidad_peq}</span>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                        <div className="ubicacion-stock-total">
                                          <strong>Stock en esta ubicación:</strong> {ubicacion.stock_unidades} uds
                                        </div>
                                      </div>
                                      <div className="ubicacion-details">
                                        <div className="ubicacion-detail-item"><label>Zona:</label><span>Zona {ubicacion.zona_id}</span></div>
                                        <div className="ubicacion-detail-item"><label>Línea:</label><span>Línea {ubicacion.linea_id}</span></div>
                                        <div className="ubicacion-detail-item"><label>Columna:</label><span>Columna {ubicacion.columna_id}</span></div>
                                        <div className="ubicacion-detail-item"><label>Nivel:</label><span>Nivel {ubicacion.nivel_id}</span></div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="modal-btn secondary" onClick={() => setShowDetailModal(false)}>Cerrar</button>
              <button className="modal-btn primary" onClick={() => { setShowDetailModal(false); handleEdit(selectedProduct); }}>
                Editar Producto
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal edición ── */}
      {showEditModal && editingProduct && (
        <div className="modal-overlay" onClick={handleCloseEditModal}>
          <div className="modal-content-edit" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Editar Producto: {editingProduct.codigo_barras_minima || editingProduct.cod_articulo}</h3>
              <button className="modal-close" onClick={handleCloseEditModal}><X size={20} /></button>
            </div>
            <div className="modal-body-edit">
              {/* Imagen */}
              <div className="product-image-section-modal">
                <div className="image-section-header">
                  <div className="image-title">
                    <ImageIcon className="image-title-icon" />
                    <h5>Imagen del Producto</h5>
                  </div>
                  <div className="image-mode-toggle">
                    <button className={`image-mode-btn ${imageUploadMode === "file" ? "active" : ""}`} onClick={() => setImageUploadMode("file")}>
                      <Upload size={14} /><span>Archivo</span>
                    </button>
                    <button className={`image-mode-btn ${imageUploadMode === "url" ? "active" : ""}`} onClick={() => setImageUploadMode("url")}>
                      <LinkIcon size={14} /><span>URL</span>
                    </button>
                  </div>
                </div>
                <div className="image-upload-container">
                  {(imagePreview || editFormData.imagen_url) && (
                    <div className="image-preview-wrapper">
                      <img src={imagePreview || editFormData.imagen_url} alt="Preview" className="image-preview" />
                      <button className="remove-image-btn" onClick={handleRemoveImage} type="button"><XCircle size={20} /></button>
                    </div>
                  )}
                  {imageUploadMode === "file" && !imagePreview && (
                    <div className="upload-file-area">
                      <input type="file" onChange={handleProductImageSelect} accept="image/jpeg,image/png,image/gif,image/webp" className="file-input-hidden" id="edit-product-image" />
                      <label htmlFor="edit-product-image" className="upload-dropzone">
                        <div className="upload-icon-container"><ImageIcon size={32} /></div>
                        <p className="upload-text-main">Haz clic para seleccionar</p>
                        <p className="upload-text-sub">JPG, PNG, GIF, WEBP (max. 5MB)</p>
                      </label>
                      {imageFile && !editFormData.imagen_url && (
                        <button className="upload-confirm-btn" onClick={handleUploadImageFromFile} disabled={uploadingImage}>
                          {uploadingImage ? <><div className="mini-loader"></div><span>Subiendo...</span></> : <><Upload size={16} /><span>Subir Imagen</span></>}
                        </button>
                      )}
                    </div>
                  )}
                  {imageUploadMode === "url" && !imagePreview && (
                    <div className="upload-url-area">
                      <div className="url-input-group">
                        <LinkIcon className="url-input-icon" />
                        <input type="url" placeholder="https://ejemplo.com/imagen.jpg" value={imageUrl} onChange={(e) => setImageUrl(e.target.value)} className="url-input" />
                      </div>
                      <button className="upload-confirm-btn" onClick={handleUploadImageFromUrl} disabled={uploadingImage || !imageUrl.trim()}>
                        {uploadingImage ? <><div className="mini-loader"></div><span>Cargando...</span></> : <><LinkIcon size={16} /><span>Cargar desde URL</span></>}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {editingProduct.stock_lotes?.lotes && editingProduct.stock_lotes.lotes.length > 0 && (
                <div className="edit-lotes-info">
                  <AlertTriangle size={16} />
                  <span>Este producto tiene <strong>{editingProduct.stock_lotes.lotes.length} lote(s)</strong> asignado(s). Los lotes no se pueden editar desde aquí. Use el módulo de ingresos/salidas para gestionar stock.</span>
                </div>
              )}

              <div className="edit-form-sections">
                {/* Información Básica */}
                <div className="edit-section">
                  <h4 className="section-title">Información Básica</h4>
                  <div className="edit-grid-compact">
                    <div className="input-group">
                      <label>BC Mayor ({editFormData.unidad_mayor || 'Caja'})</label>
                      <input type="text" value={editFormData.codigo_barras_mayor} onChange={(e) => setEditFormData(prev => ({ ...prev, codigo_barras_mayor: e.target.value }))} className="edit-input" placeholder="Opcional" />
                    </div>
                    <div className="input-group">
                      <label>BC Intermedia ({editFormData.unidad_display || 'Display'})</label>
                      <input type="text" value={editFormData.codigo_barras_intermedia} onChange={(e) => setEditFormData(prev => ({ ...prev, codigo_barras_intermedia: e.target.value }))} className="edit-input" placeholder="Opcional" />
                    </div>
                    <div className="input-group">
                      <label>BC Mínima ({editFormData.unidad_base || 'Unidad'}) *</label>
                      <input type="text" value={editFormData.codigo_barras_minima} onChange={(e) => setEditFormData(prev => ({ ...prev, codigo_barras_minima: e.target.value }))} className="edit-input" />
                    </div>
                    <div className="input-group">
                      <label>Código Artículo</label>
                      <input type="text" value={editFormData.cod_articulo} onChange={(e) => setEditFormData(prev => ({ ...prev, cod_articulo: e.target.value }))} className="edit-input" />
                    </div>
                    <div className="input-group full-width">
                      <label>Descripción</label>
                      <input type="text" value={editFormData.descripcion} onChange={(e) => setEditFormData(prev => ({ ...prev, descripcion: e.target.value }))} className="edit-input" />
                    </div>
                  </div>
                </div>

                {/* Proveedor */}
                <div className="edit-section">
                  <h4 className="section-title">Proveedor</h4>
                  <div className="edit-grid-compact">
                    <div className="input-group">
                      <label>Proveedor</label>
                      <select value={editFormData.proveedor_id} onChange={(e) => setEditFormData(prev => ({ ...prev, proveedor_id: e.target.value }))} className="edit-select">
                        <option value="">Seleccionar Proveedor</option>
                        {proveedores.map((prov) => <option key={prov.id} value={prov.id}>{prov.nombre}</option>)}
                      </select>
                    </div>
                    <div className="input-group">
                      <label>Unidad de Negocio</label>
                      <input type="text" value={editFormData.unidad_negocio_proveedor} onChange={(e) => setEditFormData(prev => ({ ...prev, unidad_negocio_proveedor: e.target.value }))} className="edit-input" />
                    </div>
                    <div className="input-group">
                      <label>Código Artículo Prov.</label>
                      <input type="text" value={editFormData.codigo_articulo_proveedor} onChange={(e) => setEditFormData(prev => ({ ...prev, codigo_articulo_proveedor: e.target.value }))} className="edit-input" />
                    </div>
                  </div>
                </div>

                {/* Clasificación */}
                <div className="edit-section">
                  <h4 className="section-title">Clasificación</h4>
                  <div className="edit-grid-compact">
                    <div className="input-group">
                      <label>Familia</label>
                      <select value={editFormData.familia_id} onChange={(e) => setEditFormData(prev => ({ ...prev, familia_id: e.target.value }))} className="edit-select">
                        <option value="">Seleccionar Familia</option>
                        {familias.map((fam) => <option key={fam.id} value={fam.id}>{fam.nombre}</option>)}
                      </select>
                    </div>
                    <div className="input-group">
                      <label>SubFamilia</label>
                      <select value={editFormData.subfamilia_id} onChange={(e) => setEditFormData(prev => ({ ...prev, subfamilia_id: e.target.value }))} className="edit-select" disabled={!editFormData.familia_id}>
                        <option value="">Seleccionar SubFamilia</option>
                        {subfamilias.map((sub) => <option key={sub.id} value={sub.id}>{sub.nombre}</option>)}
                      </select>
                    </div>
                    <div className="input-group">
                      <label>Categoría</label>
                      <select value={editFormData.categoria_id} onChange={(e) => setEditFormData(prev => ({ ...prev, categoria_id: e.target.value }))} className="edit-select">
                        <option value="">Seleccionar Categoría</option>
                        {categorias.map((cat) => <option key={cat.id} value={cat.id}>{cat.nombre}</option>)}
                      </select>
                    </div>
                    <div className="input-group">
                      <label>SubCategoría</label>
                      <select value={editFormData.subcategoria_id} onChange={(e) => setEditFormData(prev => ({ ...prev, subcategoria_id: e.target.value }))} className="edit-select" disabled={!editFormData.categoria_id}>
                        <option value="">Seleccionar SubCategoría</option>
                        {subcategorias.map((sub) => <option key={sub.id} value={sub.id}>{sub.nombre}</option>)}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Unidades de Medida */}
                <div className="edit-section">
                  <h4 className="section-title">Unidades de Medida Jerárquicas</h4>
                  <div className="stock-level-card-edit nivel-mayor">
                    <div className="stock-level-header-edit"><Package size={16} /><strong>Nivel 1: Unidad Mayor (Obligatorio)</strong></div>
                    <div className="edit-grid-stock">
                      <div className="input-group">
                        <label>Tipo de Unidad *</label>
                        <select value={editFormData.unidad_mayor} onChange={(e) => setEditFormData(prev => ({ ...prev, unidad_mayor: e.target.value }))} className="edit-select">
                          <option value="">Seleccionar</option>
                          {unidadesMedidaOptions.map((u) => <option key={u} value={u}>{u}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>
                  <button type="button" className={`level-toggle-btn-edit ${hasDisplay ? 'active' : ''}`} onClick={toggleDisplayLevel}>
                    {hasDisplay ? <Check size={14} /> : <Plus size={14} />}<Layers3 size={16} />
                    <span>{hasDisplay ? 'Nivel Display Activo' : 'Agregar Nivel Display'}</span>
                  </button>
                  {hasDisplay && (
                    <div className="stock-level-card-edit nivel-display">
                      <div className="stock-level-header-edit"><Layers3 size={16} /><strong>Nivel 2: Display (Intermedio)</strong></div>
                      <div className="edit-grid-stock">
                        <div className="input-group">
                          <label>Tipo de Display</label>
                          <select value={editFormData.unidad_display} onChange={(e) => setEditFormData(prev => ({ ...prev, unidad_display: e.target.value }))} className="edit-select">
                            <option value="">Seleccionar</option>
                            {unidadesMedidaOptions.map((u) => <option key={u} value={u}>{u}</option>)}
                          </select>
                        </div>
                        <div className="input-group">
                          <label>Cantidad por U. Mayor</label>
                          <input type="number" value={editFormData.cantidad_display_por_unidad_mayor} onChange={(e) => setEditFormData(prev => ({ ...prev, cantidad_display_por_unidad_mayor: e.target.value }))} className="edit-input" min="1" placeholder="Ej: 10" />
                        </div>
                      </div>
                    </div>
                  )}
                  <button type="button" className={`level-toggle-btn-edit ${hasUnidadBase ? 'active' : ''}`} onClick={toggleUnidadBaseLevel}>
                    {hasUnidadBase ? <Check size={14} /> : <Plus size={14} />}<PackageOpen size={16} />
                    <span>{hasUnidadBase ? 'Nivel Unidad Base Activo' : 'Agregar Nivel Unidad Base'}</span>
                  </button>
                  {hasUnidadBase && (
                    <div className="stock-level-card-edit nivel-base">
                      <div className="stock-level-header-edit"><PackageOpen size={16} /><strong>Nivel 3: Unidad Base (Más Pequeña)</strong></div>
                      <div className="edit-grid-stock">
                        <div className="input-group">
                          <label>Tipo de U. Base</label>
                          <select value={editFormData.unidad_base} onChange={(e) => setEditFormData(prev => ({ ...prev, unidad_base: e.target.value }))} className="edit-select">
                            <option value="">Seleccionar</option>
                            {unidadesMedidaOptions.map((u) => <option key={u} value={u}>{u}</option>)}
                          </select>
                        </div>
                        <div className="input-group">
                          <label>Cantidad por Display</label>
                          <input type="number" value={editFormData.cantidad_unidad_base_por_display} onChange={(e) => setEditFormData(prev => ({ ...prev, cantidad_unidad_base_por_display: e.target.value }))} className="edit-input" min="1" placeholder="Ej: 24" />
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Costos */}
                <div className="edit-section">
                  <h4 className="section-title">Costos y Precios</h4>
                  <div className="edit-grid-compact">
                    <div className="input-group">
                      <label>Costo Real</label>
                      <input type="number" value={editFormData.costo_real} onChange={(e) => setEditFormData(prev => ({ ...prev, costo_real: e.target.value }))} className="edit-input" min="0" step="0.01" />
                    </div>
                    <div className="input-group">
                      <label>Costo Promedio</label>
                      <input type="number" value={editFormData.costo_promedio} onChange={(e) => setEditFormData(prev => ({ ...prev, costo_promedio: e.target.value }))} className="edit-input" min="0" step="0.01" />
                    </div>
                    <div className="input-group">
                      <label>Precio de Venta</label>
                      <input type="number" value={editFormData.price} onChange={(e) => setEditFormData(prev => ({ ...prev, price: e.target.value }))} className="edit-input" min="0" step="0.01" />
                    </div>
                  </div>
                </div>

                {/* Medidas y Almacén */}
                <div className="edit-section">
                  <h4 className="section-title">Medidas y Almacén</h4>
                  <div className="edit-grid-compact">
                    <div className="input-group">
                      <label>Peso (kg)</label>
                      <input type="number" value={editFormData.peso} onChange={(e) => setEditFormData(prev => ({ ...prev, peso: e.target.value }))} className="edit-input" min="0" step="0.01" />
                    </div>
                    <div className="input-group">
                      <label>Volumen (cm³)</label>
                      <input type="number" value={editFormData.volumen} onChange={(e) => setEditFormData(prev => ({ ...prev, volumen: e.target.value }))} className="edit-input" min="0" step="0.01" />
                    </div>
                    <div className="input-group">
                      <label>Código de Almacén</label>
                      <select value={editFormData.cod_almacen} onChange={(e) => setEditFormData(prev => ({ ...prev, cod_almacen: e.target.value }))} className="edit-select">
                        <option value="">Seleccionar Almacén</option>
                        {almacenesOptions.map((a) => <option key={a} value={a}>{a}</option>)}
                      </select>
                    </div>
                    <div className="input-group">
                      <label>Stock Mínimo</label>
                      <input type="number" value={editFormData.min_stock} onChange={(e) => setEditFormData(prev => ({ ...prev, min_stock: e.target.value }))} className="edit-input" min="0" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-btn secondary" onClick={handleCloseEditModal}>Cancelar</button>
              <button className="modal-btn primary" onClick={handleUpdate}>Actualizar Producto</button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        /* ─────────────────────────────────────────
           CONTENEDOR PRINCIPAL
           background transparent para NO crear
           ninguna tarjeta blanca extra.
        ───────────────────────────────────────── */
        .products-list {
          padding: 0;
          background: transparent;
          width: 100%;
          box-sizing: border-box;
          /* Evita cualquier scroll horizontal a nivel del componente */
          overflow-x: hidden;
        }

        /* ─────────────────────────────────────────
           LOADING
        ───────────────────────────────────────── */
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 400px;
          gap: 20px;
        }
        .loader-ring {
          width: 60px; height: 60px;
          border: 4px solid rgba(59,130,246,0.1);
          border-top: 4px solid #3B82F6;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }

        /* ─────────────────────────────────────────
           FILTROS
           Sin fondo, sin borde, sin sombra.
           La separación visual respecto a la tabla
           la da únicamente el margin-bottom.
        ───────────────────────────────────────── */
        .products-header {
          margin-bottom: 16px;
          /* SIN background, SIN border, SIN box-shadow */
          background: transparent;
        }

        .search-filters {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          width: 100%;
        }

        .search-wrapper {
          position: relative;
          flex: 1;
          min-width: 200px;
        }
        .search-icon {
          position: absolute;
          left: 11px; top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          width: 15px; height: 15px;
          pointer-events: none;
        }
        .search-input {
          width: 100%;
          padding: 9px 12px 9px 34px;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          font-size: 13px;
          background: white;
          box-sizing: border-box;
          transition: border-color .2s, box-shadow .2s;
        }
        .search-input:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59,130,246,.1);
        }

        .filter-wrapper {
          position: relative;
          min-width: 155px;
          flex: 0 1 auto;
        }
        .filter-icon {
          position: absolute;
          left: 11px; top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          width: 15px; height: 15px;
          pointer-events: none;
        }
        .filter-select {
          width: 100%;
          padding: 9px 12px 9px 34px;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          font-size: 13px;
          background: white;
          color: #1a1a1a;
          box-sizing: border-box;
          appearance: auto;
          transition: border-color .2s;
        }
        .filter-select:focus { outline: none; border-color: #3b82f6; }

        /* ─────────────────────────────────────────
           TABLA — TARJETA
        ───────────────────────────────────────── */
        .glass-panel {
          background: white;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 1px 3px rgba(0,0,0,.05);
          /* overflow hidden para que los bordes
             redondeados recorten la tabla */
          overflow: hidden;
          /* ancho máximo al 100% del padre */
          width: 100%;
          box-sizing: border-box;
        }

        .table-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 14px 18px;
          border-bottom: 1px solid #e5e7eb;
        }
        .table-title {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .table-title-icon { color: #3b82f6; width: 20px; height: 20px; }
        .table-title h3 { font-size: 15px; font-weight: 600; color: #1a1a1a; margin: 0; }
        .product-count {
          font-size: 12px; color: #94a3b8;
          background: #f1f5f9;
          padding: 2px 8px; border-radius: 12px;
        }

        /* ─────────────────────────────────────────
           TABLE WRAPPER
           Permite scroll horizontal SOLO dentro
           de la tarjeta si la pantalla es muy
           pequeña, pero con table-layout:fixed
           los textos se truncan antes de eso.
        ───────────────────────────────────────── */
        .table-wrapper {
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }

        /* ─────────────────────────────────────────
           TABLE — layout fijo = columnas respetan
           los anchos del colgroup y el texto se
           corta con ellipsis en vez de expandirse.
        ───────────────────────────────────────── */
        .products-table {
          width: 100%;
          border-collapse: collapse;
          /* CLAVE: evita que el contenido desborde */
          table-layout: fixed;
        }

        .table-head-row { background: #f8fafc; }
        .products-table th {
          padding: 11px 12px;
          text-align: left;
          font-size: 11px;
          font-weight: 600;
          color: #4a4a4a;
          text-transform: uppercase;
          letter-spacing: .3px;
          border-bottom: 1px solid #e5e7eb;
          white-space: nowrap;
          overflow: hidden;
        }
        .products-table td {
          padding: 10px 12px;
          font-size: 13px;
          border-bottom: 1px solid #e5e7eb;
          color: #1a1a1a;
          /* NO overflow:hidden aquí — lo maneja .cell-truncate
             internamente para no romper botones ni badges */
          max-width: 0; /* fuerza que table-layout:fixed funcione */
        }

        /* Celda de acciones: ancho fijo, sin restricción */
        .td-actions {
          max-width: none;
          width: 108px;
          min-width: 108px;
        }

        .product-row {
          transition: background .2s;
          animation: fadeIn .4s ease forwards;
          opacity: 0;
        }
        @keyframes fadeIn { to { opacity: 1; } }
        .product-row:hover { background: #f8fafc; }

        /* ─────────────────────────────────────────
           TRUNCADO DE TEXTO
           Todas las celdas con texto largo usan
           esta clase para cortar con "…"
        ───────────────────────────────────────── */
        .cell-truncate {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;
        }

        /* Íconos inline en celdas con texto */
        .cell-icon {
          flex-shrink: 0;
          color: #94a3b8;
        }

        .no-data {
          text-align: center;
          padding: 60px 20px !important;
          color: #94a3b8;
        }
        .no-data svg { margin-bottom: 14px; opacity: .5; }
        .no-data p { margin: 0; font-size: 15px; font-weight: 500; }

        /* ── Celdas específicas ── */
        .th-image, .td-image { text-align: center; }
        .td-image { padding: 6px 12px !important; }

        .product-thumbnail-container {
          position: relative;
          width: 44px; height: 44px;
          cursor: pointer;
          overflow: hidden;
          border-radius: 6px;
          box-shadow: 0 2px 4px rgba(0,0,0,.1);
          transition: transform .25s, box-shadow .25s;
          margin: 0 auto;
        }
        .product-thumbnail-container:hover {
          transform: scale(1.06);
          box-shadow: 0 4px 12px rgba(0,0,0,.18);
        }
        .product-thumbnail-container:hover .thumbnail-overlay { opacity: 1; }
        .thumbnail-overlay {
          position: absolute; inset: 0;
          background: rgba(0,0,0,.55);
          display: flex; align-items: center; justify-content: center;
          opacity: 0; transition: opacity .25s; color: white;
        }
        .product-thumbnail { width: 44px; height: 44px; object-fit: cover; }
        .no-image-placeholder {
          width: 44px; height: 44px;
          display: flex; align-items: center; justify-content: center;
          background: #f1f5f9; border-radius: 6px; color: #94a3b8; margin: 0 auto;
        }

        .product-code {
          display: flex; align-items: center; gap: 5px;
          font-family: monospace; font-size: 12px; color: #3b82f6;
          overflow: hidden;
        }
        .product-code svg { flex-shrink: 0; }

        .supplier-info, .date-info, .location-cell {
          display: flex; align-items: center; gap: 5px; overflow: hidden;
        }

        .lotes-badge {
          display: inline-flex; align-items: center; gap: 5px;
          padding: 3px 8px; border-radius: 6px; font-size: 12px; font-weight: 600;
          background: rgba(139,92,246,.1); color: #8b5cf6;
          border: 1px solid rgba(139,92,246,.2);
          white-space: nowrap;
        }

        .family-tag {
          display: block;
          font-size: 12px; color: #059669;
          background: rgba(5,150,105,.1);
          padding: 2px 7px; border-radius: 4px;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }

        .category-badge {
          display: block;
          padding: 3px 7px; border-radius: 4px;
          font-size: 12px; font-weight: 500;
          border: 1px solid;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }

        .expiry-indicator {
          display: flex; align-items: center; gap: 6px;
          padding: 5px 8px; border-radius: 6px; font-size: 11px;
        }
        .expiry-indicator svg { flex-shrink: 0; }
        .expiry-indicator.good    { background: rgba(16,185,129,.1);  color: #10b981; }
        .expiry-indicator.warning { background: rgba(245,158,11,.1);  color: #f59e0b; }
        .expiry-indicator.critical{ background: rgba(239,68,68,.1);   color: #ef4444; }
        .expiry-indicator.expired { background: rgba(127,29,29,.1);   color: #7f1d1d; }
        .expiry-indicator.neutral { background: rgba(100,116,139,.1); color: #64748b; }
        .expiry-content { display: flex; flex-direction: column; gap: 1px; overflow: hidden; }
        .expiry-date { font-weight: 600; white-space: nowrap; }
        .expiry-days { font-size: 10px; opacity: .8; white-space: nowrap; }

        .stock-indicator {
          display: flex; align-items: center; gap: 5px;
          padding: 4px 7px; border-radius: 4px;
          font-weight: 600; font-size: 12px; white-space: nowrap;
        }
        .stock-indicator.good    { background: rgba(16,185,129,.1);  color: #10b981; }
        .stock-indicator.low     { background: rgba(245,158,11,.1);  color: #f59e0b; }
        .stock-indicator.out     { background: rgba(239,68,68,.1);   color: #ef4444; }

        .status-badge {
          display: inline-flex; align-items: center; gap: 5px;
          padding: 3px 7px; border-radius: 4px;
          font-size: 11px; font-weight: 500; white-space: nowrap;
        }
        .status-badge.good      { background: rgba(16,185,129,.1);  color: #10b981; }
        .status-badge.defective { background: rgba(239,68,68,.1);   color: #ef4444; }

        .text-muted { color: #94a3b8; font-style: italic; font-size: 12px; }

        /* Acciones */
        .action-buttons {
          display: flex;
          gap: 6px;
          flex-wrap: nowrap;   /* nunca rompe en dos líneas */
          align-items: center;
        }
        .action-btn {
          display: flex; align-items: center; justify-content: center;
          width: 28px; height: 28px; border-radius: 6px;
          border: 1px solid #e5e7eb; background: #f9fafb;
          cursor: pointer; transition: all .2s;
          flex-shrink: 0;   /* nunca se comprime */
          flex-grow: 0;
        }
        .view-btn   { color: #3b82f6; }
        .view-btn:hover   { background: rgba(59,130,246,.1);  border-color: #3b82f6; }
        .edit-btn   { color: #f59e0b; }
        .edit-btn:hover   { background: rgba(245,158,11,.1);  border-color: #f59e0b; }
        .delete-btn { color: #ef4444; }
        .delete-btn:hover { background: rgba(239,68,68,.1);   border-color: #ef4444; }

        /* ─────────────────────────────────────────
           MODALES
        ───────────────────────────────────────── */
        .modal-overlay {
          position: fixed; inset: 0;
          background: rgba(0,0,0,.5);
          display: flex; align-items: center; justify-content: center;
          z-index: 1000;
          backdrop-filter: blur(4px);
          padding: 20px;
          overflow-y: auto;
        }

        .modal-content-detail,
        .modal-content-edit,
        .modal-content-image {
          background: white;
          border-radius: 12px;
          width: 100%; max-height: 90vh;
          overflow: hidden;
          box-shadow: 0 20px 25px -5px rgba(0,0,0,.2);
          display: flex; flex-direction: column;
        }
        .modal-content-detail { max-width: 1000px; }
        .modal-content-edit   { max-width: 850px;  }
        .modal-content-image  { max-width: 90vw;   }

        .modal-header {
          display: flex; justify-content: space-between; align-items: center;
          padding: 18px 22px; border-bottom: 1px solid #e5e7eb; flex-shrink: 0;
        }
        .modal-header h3 { margin: 0; font-size: 17px; font-weight: 600; }

        .image-modal-actions { display: flex; gap: 8px; }
        .image-modal-btn {
          display: flex; align-items: center; justify-content: center;
          width: 34px; height: 34px; border-radius: 8px;
          border: 1px solid #e5e7eb; background: white;
          cursor: pointer; transition: all .2s;
        }
        .download-btn { color: #3b82f6; }
        .download-btn:hover { background: #3b82f6; color: white; border-color: #3b82f6; }
        .close-btn { color: #6b7280; }
        .close-btn:hover { background: #ef4444; color: white; border-color: #ef4444; }

        .modal-close {
          display: flex; align-items: center; justify-content: center;
          width: 34px; height: 34px; border-radius: 8px;
          border: 1px solid #e5e7eb; background: #f9fafb;
          color: #6b7280; cursor: pointer; transition: all .2s;
        }
        .modal-close:hover { background: #ef4444; color: white; border-color: #ef4444; }

        .modal-body-detail,
        .modal-body-edit { padding: 22px; overflow-y: auto; flex: 1; }

        .modal-body-image {
          flex: 1; display: flex; align-items: center; justify-content: center;
          padding: 20px; background: #f8f9fa; overflow: auto;
        }
        .modal-image-large {
          max-width: 100%; max-height: 70vh;
          object-fit: contain; border-radius: 8px;
          box-shadow: 0 10px 25px rgba(0,0,0,.15);
        }

        .modal-footer {
          padding: 14px 22px; border-top: 1px solid #e5e7eb;
          display: flex; justify-content: flex-end; gap: 10px; flex-shrink: 0;
        }
        .modal-btn {
          padding: 9px 18px; border-radius: 8px;
          font-size: 13px; font-weight: 500; cursor: pointer;
          transition: all .2s; border: none;
        }
        .modal-btn.secondary { background: #f9fafb; color: #6b7280; border: 1px solid #e5e7eb; }
        .modal-btn.secondary:hover { background: #f1f5f9; }
        .modal-btn.primary { background: #3b82f6; color: white; }
        .modal-btn.primary:hover { background: #2563eb; }

        /* Imagen en modal detalle */
        .product-image-display-modal {
          width: 100%; max-width: 280px;
          margin: 0 auto 20px;
          border-radius: 10px; overflow: hidden;
          border: 2px solid #e5e7eb;
          box-shadow: 0 4px 6px rgba(0,0,0,.08);
        }
        .product-image-display-modal img { width: 100%; height: auto; display: block; }

        /* Grid detalle */
        .detail-grid {
          display: grid; grid-template-columns: repeat(2,1fr);
          gap: 20px; margin-bottom: 20px;
        }
        .detail-section { background: #f9fafb; padding: 14px; border-radius: 8px; }
        .detail-section h4 {
          margin: 0 0 12px; font-size: 12px; font-weight: 700;
          color: #3b82f6; text-transform: uppercase; letter-spacing: .5px;
        }
        .detail-item {
          display: flex; justify-content: space-between;
          padding: 7px 0; border-bottom: 1px solid #e5e7eb;
        }
        .detail-item:last-child { border-bottom: none; }
        .detail-item.full-width { flex-direction: column; gap: 6px; }
        .detail-item label { font-size: 12px; color: #6b7280; font-weight: 500; }
        .detail-item span { font-size: 13px; color: #1a1a1a; font-weight: 500; text-align: right; }
        .detail-item .stock-value { padding: 3px 7px; border-radius: 4px; font-weight: 600; }
        .detail-item .stock-value.good { background: rgba(16,185,129,.1); color: #10b981; }
        .detail-item .stock-value.low  { background: rgba(245,158,11,.1); color: #f59e0b; }
        .detail-item .stock-value.out  { background: rgba(239,68,68,.1);  color: #ef4444; }

        .issues-list { margin: 6px 0 0; padding-left: 18px; }
        .issues-list li { margin-bottom: 3px; color: #ef4444; font-size: 12px; }

        /* Lotes */
        .lotes-section { margin-top: 20px; padding-top: 20px; border-top: 2px solid #e5e7eb; }
        .lotes-title {
          display: flex; align-items: center; gap: 8px;
          margin: 0 0 16px; font-size: 15px; font-weight: 600; color: #1a1a1a;
        }
        .lotes-title svg { color: #8b5cf6; }
        .lotes-list { display: flex; flex-direction: column; gap: 10px; }

        .lote-card {
          background: white; border: 2px solid #e5e7eb;
          border-radius: 10px; overflow: hidden; transition: border-color .25s, box-shadow .25s;
        }
        .lote-card:hover { border-color: #8b5cf6; box-shadow: 0 4px 12px rgba(139,92,246,.1); }

        .lote-header {
          display: flex; justify-content: space-between; align-items: center;
          padding: 12px 16px;
          background: linear-gradient(135deg,#f8f9fa,#f1f5f9);
          cursor: pointer; transition: background .25s;
        }
        .lote-header:hover { background: linear-gradient(135deg,#f1f5f9,#e0e7ff); }
        .lote-header-left  { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
        .lote-header-right { display: flex; align-items: center; gap: 14px; }

        .lote-number {
          font-size: 12px; font-weight: 700; color: #8b5cf6;
          background: rgba(139,92,246,.1); padding: 3px 9px; border-radius: 6px;
        }
        .lote-code { font-family: monospace; font-size: 12px; font-weight: 600; color: #1a1a1a; }

        .lote-expiry-badge {
          display: inline-flex; align-items: center; gap: 4px;
          padding: 3px 7px; border-radius: 6px; font-size: 11px; font-weight: 600;
        }
        .lote-expiry-badge.good    { background: rgba(16,185,129,.1);  color: #10b981; }
        .lote-expiry-badge.warning { background: rgba(245,158,11,.1);  color: #f59e0b; }
        .lote-expiry-badge.critical{ background: rgba(239,68,68,.1);   color: #ef4444; }
        .lote-expiry-badge.expired { background: rgba(127,29,29,.1);   color: #7f1d1d; }

        .lote-stock, .lote-cajas { font-size: 12px; font-weight: 600; color: #3b82f6; }
        .lote-body { padding: 16px; background: white; }
        .lote-info-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 10px; margin-bottom: 14px; }
        .lote-info-item { display: flex; flex-direction: column; gap: 3px; }
        .lote-info-item label { font-size: 10px; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: .5px; }
        .lote-info-item span  { font-size: 13px; font-weight: 600; color: #1a1a1a; }
        .expiry-text.good    { color: #10b981; }
        .expiry-text.warning { color: #f59e0b; }
        .expiry-text.critical{ color: #ef4444; }
        .expiry-text.expired { color: #7f1d1d; }

        .lote-ubicaciones-section { margin-top: 14px; padding-top: 14px; border-top: 1px dashed #e5e7eb; }
        .lote-ubicaciones-section h5 { font-size: 11px; font-weight: 700; color: #4a4a4a; text-transform: uppercase; margin: 0 0 10px; letter-spacing: .5px; }

        .ubicacion-item { margin-bottom: 14px; padding: 12px; background: #f9fafb; border-radius: 8px; border: 1px solid #e5e7eb; }
        .ubicacion-item:last-child { margin-bottom: 0; }

        .lote-stock-section { margin-bottom: 10px; }
        .lote-stock-section h5 { font-size: 11px; font-weight: 700; color: #4a4a4a; text-transform: uppercase; margin: 0 0 8px; letter-spacing: .5px; }

        .lote-stock-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 8px; }
        .lote-stock-item {
          display: flex; align-items: center; gap: 8px;
          padding: 8px; border-radius: 8px; border: 2px solid; background: white;
        }
        .lote-stock-item.nivel-mayor  { border-color: rgba(59,130,246,.3);  }
        .lote-stock-item.nivel-display{ border-color: rgba(16,185,129,.3);  }
        .lote-stock-item.nivel-base   { border-color: rgba(245,158,11,.3);  }

        .stock-level-icon {
          display: flex; align-items: center; justify-content: center;
          width: 28px; height: 28px; border-radius: 6px; background: white; flex-shrink: 0;
        }
        .nivel-mayor  .stock-level-icon { color: #3b82f6; }
        .nivel-display.stock-level-icon { color: #10b981; }
        .nivel-base   .stock-level-icon { color: #f59e0b; }

        .stock-level-info { display: flex; flex-direction: column; gap: 1px; }
        .stock-level-label { font-size: 9px; font-weight: 600; color: #6b7280; text-transform: uppercase; }
        .stock-level-value { font-size: 15px; font-weight: 700; color: #1a1a1a; }

        .ubicacion-stock-total { margin-top: 8px; padding: 6px 10px; background: rgba(59,130,246,.05); border-radius: 6px; font-size: 12px; color: #1a1a1a; }

        .ubicacion-badge {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 6px 12px;
          background: linear-gradient(135deg,#3b82f6,#2563eb);
          color: white; border-radius: 8px; font-weight: 600; margin-bottom: 10px;
        }
        .ubicacion-code { font-family: monospace; font-size: 13px; }

        .ubicacion-details { display: grid; grid-template-columns: repeat(2,1fr); gap: 6px; padding: 10px; background: white; border-radius: 8px; margin-top: 10px; }
        .ubicacion-detail-item { display: flex; flex-direction: column; gap: 2px; }
        .ubicacion-detail-item label { font-size: 9px; font-weight: 600; color: #6b7280; text-transform: uppercase; }
        .ubicacion-detail-item span  { font-size: 12px; font-weight: 600; color: #1a1a1a; }

        /* ─────────────────────────────────────────
           MODAL EDICIÓN — IMAGEN
        ───────────────────────────────────────── */
        .product-image-section-modal {
          margin-bottom: 18px; padding: 14px;
          background: linear-gradient(135deg,#f0f9ff,#e0f2fe);
          border-radius: 10px; border: 2px dashed #e5e7eb;
        }
        .image-section-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
        .image-title { display: flex; align-items: center; gap: 7px; }
        .image-title-icon { color: #3b82f6; width: 16px; height: 16px; }
        .image-title h5 { font-size: 13px; font-weight: 600; margin: 0; color: #1a1a1a; }

        .image-mode-toggle { display: flex; gap: 3px; background: white; padding: 3px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,.08); }
        .image-mode-btn {
          display: flex; align-items: center; gap: 5px;
          padding: 5px 10px; border: none; border-radius: 6px;
          background: transparent; color: #64748b; font-size: 11px; font-weight: 500;
          cursor: pointer; transition: all .2s;
        }
        .image-mode-btn.active { background: #3b82f6; color: white; }
        .image-mode-btn:hover:not(.active) { background: #f1f5f9; }

        .image-upload-container { position: relative; }
        .image-preview-wrapper { position: relative; width: 100%; max-width: 240px; margin: 0 auto; border-radius: 10px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,.1); }
        .image-preview { width: 100%; height: auto; display: block; object-fit: cover; max-height: 240px; }
        .remove-image-btn {
          position: absolute; top: 7px; right: 7px;
          width: 30px; height: 30px; border-radius: 50%;
          border: none; background: rgba(239,68,68,.9); color: white;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all .2s;
        }
        .remove-image-btn:hover { background: #ef4444; transform: scale(1.1); }

        .upload-file-area { display: flex; flex-direction: column; gap: 8px; }
        .file-input-hidden { display: none; }
        .upload-dropzone {
          border: 2px dashed #e5e7eb; border-radius: 10px;
          padding: 20px 14px; text-align: center; cursor: pointer;
          transition: all .2s; background: white;
        }
        .upload-dropzone:hover { border-color: #3b82f6; background: rgba(59,130,246,.04); }
        .upload-icon-container { width: 44px; height: 44px; margin: 0 auto 8px; background: linear-gradient(135deg,#3b82f6,#2563eb); border-radius: 10px; display: flex; align-items: center; justify-content: center; color: white; }
        .upload-text-main { font-size: 12px; font-weight: 600; color: #1a1a1a; margin: 0 0 3px; }
        .upload-text-sub  { font-size: 11px; color: #94a3b8; margin: 0; }

        .upload-url-area { display: flex; flex-direction: column; gap: 8px; }
        .url-input-group { position: relative; width: 100%; }
        .url-input-icon { position: absolute; left: 11px; top: 50%; transform: translateY(-50%); color: #94a3b8; width: 15px; height: 15px; pointer-events: none; }
        .url-input { width: 100%; padding: 9px 10px 9px 35px; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 12px; background: white; color: #1a1a1a; box-sizing: border-box; }
        .url-input:focus { outline: none; border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }

        .upload-confirm-btn {
          display: flex; align-items: center; justify-content: center; gap: 7px;
          padding: 9px 14px; background: #3b82f6; color: white;
          border: none; border-radius: 8px; font-size: 12px; font-weight: 600;
          cursor: pointer; transition: all .2s;
        }
        .upload-confirm-btn:hover:not(:disabled) { background: #2563eb; transform: translateY(-1px); }
        .upload-confirm-btn:disabled { background: #cbd5e1; cursor: not-allowed; }

        .mini-loader {
          width: 13px; height: 13px;
          border: 2px solid rgba(255,255,255,.3);
          border-top: 2px solid white;
          border-radius: 50%; animation: spin 1s linear infinite;
        }

        .edit-lotes-info {
          display: flex; align-items: center; gap: 9px;
          padding: 10px 14px;
          background: linear-gradient(135deg,rgba(245,158,11,.1),rgba(245,158,11,.05));
          border: 1px solid rgba(245,158,11,.3);
          border-radius: 8px; margin-bottom: 18px;
          font-size: 12px; color: #92400e;
        }
        .edit-lotes-info svg { color: #f59e0b; flex-shrink: 0; }

        /* ─── Formulario edición ─── */
        .edit-form-sections { display: flex; flex-direction: column; gap: 14px; }
        .edit-section { background: #f9fafb; border-radius: 10px; padding: 14px; border: 1px solid #e5e7eb; }
        .section-title {
          margin: 0 0 11px; font-size: 11px; font-weight: 700;
          color: #3b82f6; text-transform: uppercase; letter-spacing: .5px;
          display: flex; align-items: center; gap: 5px;
        }

        .edit-grid-compact { display: grid; grid-template-columns: repeat(2,1fr); gap: 10px; }
        .edit-grid-compact .input-group { display: flex; flex-direction: column; gap: 5px; }
        .edit-grid-compact .input-group.full-width { grid-column: 1 / -1; }
        .edit-grid-compact label { font-size: 11px; font-weight: 600; color: #4a4a4a; }

        .edit-input, .edit-select {
          padding: 7px 9px; border: 1px solid #e5e7eb;
          border-radius: 6px; font-size: 12px; background: white; color: #1a1a1a;
          box-sizing: border-box; width: 100%;
          transition: border-color .2s, box-shadow .2s;
        }
        .edit-input:focus, .edit-select:focus { outline: none; border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }
        .edit-select:disabled { background: #f1f5f9; color: #94a3b8; cursor: not-allowed; }

        .stock-level-card-edit { margin-bottom: 10px; border-radius: 8px; border: 2px solid; overflow: hidden; background: white; }
        .stock-level-card-edit.nivel-mayor  { border-color: #3B82F6; background: linear-gradient(135deg,rgba(59,130,246,.05),rgba(59,130,246,.02)); }
        .stock-level-card-edit.nivel-display{ border-color: #10B981; background: linear-gradient(135deg,rgba(16,185,129,.05),rgba(16,185,129,.02)); }
        .stock-level-card-edit.nivel-base   { border-color: #F59E0B; background: linear-gradient(135deg,rgba(245,158,11,.05),rgba(245,158,11,.02)); }
        .stock-level-header-edit { display: flex; align-items: center; gap: 7px; padding: 9px 11px; background: rgba(255,255,255,.8); border-bottom: 1px solid rgba(0,0,0,.05); font-size: 11px; }

        .edit-grid-stock { display: grid; grid-template-columns: repeat(2,1fr); gap: 9px; padding: 11px; }

        .level-toggle-btn-edit {
          width: 100%; display: flex; align-items: center; gap: 7px;
          padding: 8px 11px; margin-bottom: 8px;
          border: 2px dashed #e5e7eb; border-radius: 8px;
          background: white; color: #64748b; font-size: 11px; font-weight: 500;
          cursor: pointer; transition: all .2s;
        }
        .level-toggle-btn-edit:hover { border-color: #3b82f6; background: rgba(59,130,246,.02); color: #3b82f6; }
        .level-toggle-btn-edit.active { border-color: #10b981; background: rgba(16,185,129,.05); color: #10b981; border-style: solid; }

        .input-group { display: flex; flex-direction: column; gap: 5px; }

        /* ─────────────────────────────────────────
           RESPONSIVE
        ───────────────────────────────────────── */
        @media (max-width: 1200px) {
          .detail-grid { grid-template-columns: 1fr; }
          .lote-stock-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 768px) {
          .search-filters { flex-direction: column; }
          .search-wrapper, .filter-wrapper { width: 100%; min-width: unset; }
          .edit-grid-compact { grid-template-columns: 1fr; }
          .edit-grid-stock { grid-template-columns: 1fr; }
          .modal-content-edit, .modal-content-detail { max-width: 95vw; }
          .modal-overlay { padding: 10px; }
          .lote-info-grid { grid-template-columns: 1fr; }
          .ubicacion-details { grid-template-columns: 1fr; }
        }
      `}</style>
    </div>
  );
};

export default ProductsList;